<template>
    <calendar
        class="vh-custom-calendar"
        :masks="masks"
        :attributes="attributes"
        is-expanded
        @did-move="changeMonth">
        <template v-slot:day-content="{ day, attributes }">
            
            <div>
                <vh-grid :gutter="'small'">
                    <div class="vh-width-expand">
                        <small class="vh-text-bold">
                            {{ day.day }}
                        </small>
                    </div>
                    <div class="vh-text-right"
                        v-if="!isLoading">
                        <!-- <vh-button
                            :color="'primary'"
                            :outline="true"
                            :rounded="'semi'"
                            :text="true"
                            @click="onCreate(day)">
                            <i class="ti-plus"></i>
                        </vh-button> -->
                    </div>
                </vh-grid>

                <div v-if="!isLoading">
                    <div v-for="(attr, index) in attributes"
                        :key="index"
                        class="vh-margin-small-top vh-text-center">
                        <a class="vh-link-reset vh-point"
                            @click="onView(attr.customData.data)">
                            <div class="vh-booking-room"
                                :class="statusClass(attr.customData.data.status.id)">
                                {{ attr.customData.data.booking_room.hotel_booking.booking_description }}
                            </div>
                        </a>
                    </div>
                    
                </div>

                <div v-else
                    class="vh-text-center">
                    <vh-loader
                        :size="'small'" />
                </div>
                

            </div>
        </template>
    
    </calendar>
</template>

<script>

import { Calendar } from 'v-calendar';
import 'v-calendar/dist/style.css';

export default
{
    components:
    {
        Calendar
    },

    props:
    {
        attributes:
        {
            type: Array,
            default: () => {
                return [];
            },
        },

        onView:
        {
            type: Function,
            default: () => {
                console.log('onView booking...');
            }
        },

        onLoad:
        {
            type: Function
        },

        isLoading:
        {
            type: Boolean
        }
    },
    
    data()
    {
        return {
            masks:
            {
                weekdays: 'WWW',
            },
        };
    },

    computed:
    {

    },

    methods:
    {
        changeMonth(event)
        {
            this.onLoad(event[0].month, event[0].year);
        },

        statusClass(id)
        {   
            return {
                'vh-booking-room-tentative': id == 1,
                'vh-booking-room-confirmed': id == 2,
                'vh-booking-room-check-in': id == 3,
                'vh-booking-room-check-out': id == 4,
                'vh-booking-room-canceled': id == 5,
                'vh-booking-room-rebooked': id == 6,
                'vh-booking-room-no-show': id == 7
            }
        },
    }
    
};
</script>
